{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2024                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCChartAxisEditor;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF FMXLIB}
{$WARNINGS OFF}
{$HINTS OFF}
{$IF COMPILERVERSION > 30}
{$DEFINE DELPHIBERLIN}
{$IFEND}
{$HINTS ON}
{$WARNINGS ON}
{$ENDIF}

{$IFDEF VCLLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}
{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCCustomComponent, WEBLib.TMSFNCCustomControl, WEBLib.Controls,
  WEBLib.TMSFNCTypes, WEBLib.StdCtrls, WEBLib.ExtCtrls, WEBLib.Forms, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCChart, WEBLib.TMSFNCEditorButton, WEBLib.TMSFNCEditorPanel, WEBLib.TMSFNCEditorListView, WEBLib.TMSFNCBitmapEditor
  {$IFDEF FMXLIB}
  ,FMX.Types, FMX.Memo, FMX.ListBox, FMX.ComboEdit, FMX.SpinBox, FMX.Colors, FMX.Text, FMX.Edit, FMX.Layouts
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.Samples.Spin
  {$ENDIF}
  {$IFDEF LCLLIB}
  , Spin, ColorBox
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.ComCtrls
  {$ENDIF}
  {$IFNDEF LCLLIB}
  {$IFNDEF WEBLIB}
  ,UITypes
  {$ENDIF}
  ,Types
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  // version history
  // v1.0.0.0 : First Release

  {$IFDEF VCLLIB}
  CHECKBOXSIZE = 13;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 5;
  MIDHEIGHTSPAC = 10;
  BIGHEIGHTSPAC = 15;
  {$ENDIF}
  {$IFDEF LCLLIB}
  CHECKBOXSIZE = 13;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF WEBLIB}
  CHECKBOXSIZE = 17;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 15;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF FMXLIB}
  CHECKBOXSIZE = 15;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  BIGDIV = 30;
  SMALLLBLSPACE = 10;
  MIDLBLSPACE = 20;
  BIGLBLSPACE = 30;
  SMALLHORSPACE = 60;
  MIDHORSPACE = 70;
  BIGHORSPACE = 80;
//  SERIESLARGECONTROLWIDTH = 100;
  LARGECONTROLWIDTH = 100;
  SMALLCONTROLWIDTH = 45;
  VALUE_MBYES = 6;


resourcestring
  sTMSFNCChartAxisEditorOK = 'OK';
  sTMSFNCChartAxisEditorCancel = 'Cancel';

  sTMSFNCChartAxisEditorAppearance = 'Appearance';
  sTMSFNCChartAxisEditorLeft = 'Left';
  sTMSFNCChartAxisEditorTop = 'Top';
  sTMSFNCChartAxisEditorRight = 'Right';
  sTMSFNCChartAxisEditorBottom = 'Bottom';
  sTMSFNCChartAxisEditorCenter = 'Center';
  sTMSFNCChartAxisEditorHeight = 'Height';
  sTMSFNCChartAxisEditorBorder = 'Border';
  sTMSFNCChartAxisEditorLine = 'Line';
  sTMSFNCChartAxisEditorFill = 'Fill';
  sTMSFNCChartAxisEditorStroke = 'Stroke';
  sTMSFNCChartAxisEditorColor = 'Color';
  sTMSFNCChartAxisEditorColorTo = 'Color To';
  sTMSFNCChartAxisEditorVisible = 'Visible';
  sTMSFNCChartAxisEditorKind = 'Kind';
  sTMSFNCChartAxisEditorGradient = 'Gradient';
  sTMSFNCChartAxisEditorOpacity = 'Opacity';
  sTMSFNCChartAxisEditorWidth = 'Width';
  sTMSFNCChartAxisEditorAutosize = 'Autosize';
  sTMSFNCChartAxisEditorPosition = 'Position';
  sTMSFNCChartAxisEditorDisplayAtReference = 'Display at Reference';
  sTMSFNCChartAxisEditorReference = 'Reference';
  sTMSFNCChartAxisEditorXAxis = 'X-Axis';
  sTMSFNCChartAxisEditorYAxis = 'Y-Axis';
  sTMSFNCChartAxisEditorRefHint = 'This property is used in combination with the Center value.';
  sTMSFNCChartAxisEditorSaveChartMessage = 'Are you sure you want to save the changes made?';
  sTMSFNCChartAxisEditorCancelChartMessage = 'Are you sure you don''t want to save the changes made?';
type
  TTMSFNCChartAxisEditorAxisType = (eatXAxis, eatYAxis);

  TTMSFNCChartAxisEditor = class;

  {$IFDEF FMXLIB}
  TTMSFNCChartAxisEditorParent = TFmxObject;
  TTMSFNCChartAxisEditorComboBox = class(TComboBox);
  TTMSFNCChartAxisEditorSpinEdit = class(TSpinBox)
  public
    constructor Create(AOwner: TComponent); override;
  end;
  TTMSFNCChartAxisEditorColorCombo = class(TComboColorBox);
  TTMSFNCChartAxisEditorAlphaTrackBar = class(TAlphaTrackBar);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCChartAxisEditorParent = TWinControl;
  TTMSFNCChartAxisEditorComboBox = class(TComboBox)
  public
    constructor Create(AOwner: TComponent); override;
  end;
  {$IFNDEF LCLLIB}
  TTMSFNCChartAxisEditorSpinEdit = class(TSpinEdit);
  {$ENDIF}
  {$IFDEF LCLLIB}
  TTMSFNCChartAxisEditorSpinEdit = class(TFloatSpinEdit);
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCChartAxisEditorColorCombo = class(TColorBox);
  {$ENDIF}
  {$IFDEF WEBLIB}
  TTMSFNCChartAxisEditorColorCombo = class(TWebColorPicker);
  {$ENDIF}
  {$ENDIF}

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsDesktop)]
  {$ENDIF}
  TTMSFNCChartAxisEditor = class(TTMSFNCCustomComponent)
  private
    FBitmapEditor: TTMSFNCBitmapEditor;
    {$IFNDEF FMXLIB}
    FVertScrlBox: TScrollBox;
    {$ENDIF}
    {$IFDEF FMXLIB}
    FVertScrlBox: TVertScrollBox;
    FXPanFillOpacity, FXPanStrokeOpacity: TTMSFNCChartAxisEditorAlphaTrackBar;
    {$ENDIF}
    FXPanel:TTMSFNCEditorPanel;

    FXPanFillCol1, FXPanFillCol2, FXPanStrokeCol: TTMSFNCChartAxisEditorColorCombo;
    FXPanFillKind, FXPanStrokeKind, FXPanGradientKind: TTMSFNCChartAxisEditorComboBox;
    FXPanTopLeftCheck, FXPanCenterCheck, FXPanBottomRightCheck, FXPanBorderCheck, FXPanLineCheck, FXPanVisibleCheck, FXPanAutoSizeCheck, FXPanRefCheck: TCheckBox;
    FXPanAppRef, FXPanStrokeWidth, FXPanSize: TTMSFNCChartAxisEditorSpinEdit;

    FBottomLabel, FTopLabel, FSizeLabel: TLabel;

    frm: TTMSFNCCustomDesignerForm;
    FPanel: TTMSFNCEditorPanel;
    FChart: TTMSFNCChart;
    FCopyChart: TTMSFNCChart;
    FButtonOk, FButtonCancel: TTMSFNCEditorButton;
    FModified: Boolean;
    FAxis: TTMSFNCChartAxisEditorAxisType;
    procedure SetChart(const Value: TTMSFNCChart);
    function CancelChartMessage: Boolean;
    function SaveChartMessage: Boolean;
    procedure SetAxis(const Value: TTMSFNCChartAxisEditorAxisType);
  protected
    {$IFDEF CMNWEBLIB}
    procedure SetColorComboStyle(AColorcombo: TTMSFNCChartAxisEditorColorCombo);
    {$ENDIF}
    function GetInstance: NativeUInt; override;
    procedure RegisterRuntimeClasses; override;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
    procedure BuildEditor(AParent: TTMSFNCChartAxisEditorParent); virtual;
    procedure Initialize; virtual;
    procedure SetAppearance; virtual;
    procedure ClearEvents;
    procedure SetAxisProperties;
    {$IFNDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    {$ENDIF}
    {$IFDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    {$ENDIF}
    procedure DoButtonOKClick(Sender: TObject); virtual;
    procedure DoButtonCancelClick(Sender: TObject); virtual;
    procedure CreateBottomPanel(AParent: TTMSFNCChartAxisEditorParent);
    procedure DoAxisAppPosAxisChange(Sender: TObject); virtual;
    procedure DoAxisAppPosChange(Sender: TObject); virtual;
    procedure DoAxisAppFillChange(Sender: TObject); virtual;
    procedure DoAxisAppStrokeChange(Sender: TObject); virtual;
    {$IFDEF WEBLIB}
    procedure ApplyCSS(ACSS: string); virtual;
    {$ENDIF}
    function GetDocURL: string; override;
    function GetTipsURL: string; override;
  public
    constructor Create(AOwner: TComponent; AAxis: TTMSFNCChartAxisEditorAxisType = eatXAxis); reintroduce; virtual;
    destructor Destroy; override;
    {$IFDEF WEBLIB}
    procedure Execute(AProc: TModalResultProc = nil);
    {$ELSE}
    function Execute: TModalResult;
    {$ENDIF}
    procedure Assign(Source: TPersistent); override;
  published
    property Chart: TTMSFNCChart read FChart write SetChart;
    property Axis: TTMSFNCChartAxisEditorAxisType read FAxis write SetAxis default eatXAxis;
  end;

  TTMSFNCChartAxisEditorForm = class(TTMSFNCCustomDesignerForm)
  {$IFDEF WEBLIB}
  private
    FChartEditor: TTMSFNCChartAxisEditor;
  protected
    procedure Loaded; override;
    procedure LoadDFMValues; override;
  public
    constructor CreateDialogNew(AChartEditor: TTMSFNCChartAxisEditor; ACaption: string); reintroduce; virtual;
  {$ENDIF}
  end;

  TTMSFNCChartAxisEditorDialog = class(TTMSFNCChartAxisEditor);

implementation

uses
  WEBLib.TMSFNCUtils, WEBLib.Graphics, SysUtils, WEBLib.TMSFNCEditorsTools
  {$IFDEF FMXLIB}
  ,WEBLib.Dialogs
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,WEBLib.Dialogs, VCL.Themes
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.Dialogs
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,Dialogs
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.WebTools
  {$ENDIF}
  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
  ,FMX.DialogService.Sync
  {$ENDIF}
  {$ENDIF}
  ;
//{$R TMSFNCChartAxisEditor.res}

type
  TTMSFNCChartOpen = class(TTMSFNCChart);

{ TTMSFNCChartAxisEditor }

function TranslateTextEx(AText: String): String;
begin
  {$IFDEF FMXLIB}
  Result := TranslateText(AText);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  Result := AText;
  {$ENDIF}
end;

procedure TTMSFNCChartAxisEditor.Notification(AComponent: TComponent;
  AOperation: TOperation);
begin
  inherited;
  if (AOperation = opRemove) and (AComponent = FChart) then
    FChart := nil;
end;

procedure TTMSFNCChartAxisEditor.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCChartAxisEditor);
end;

procedure TTMSFNCChartAxisEditor.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCChartAxisEditor) then
    FChart := (Source as TTMSFNCChartAxisEditor).Chart;
end;

procedure TTMSFNCChartAxisEditor.BuildEditor(AParent: TTMSFNCChartAxisEditorParent);
var
  lbl1, lbl2, lbl3, lbl4 , lbl5: TLabel;
  txt: string;
begin
  if Assigned(AParent) then
  begin
    {$IFDEF FMXLIB}
    FVertScrlBox := TVertScrollBox.Create(AParent);
    FVertScrlBox.Align := TAlignLayout.Client;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FVertScrlBox := TScrollBox.Create(AParent);
    FVertScrlBox.Align := alClient;
    FVertScrlBox.Top := 0;
    {$IFDEF LCLLIB}
    FVertScrlBox.HorzScrollBar.Visible:= False;
    {$ENDIF}
    {$ENDIF}
    FVertScrlBox.Parent := AParent;
    {$IFDEF CMNWEBLIB}
    FVertScrlBox.BorderStyle := bsNone;
    if IsLightTheme then
      FVertScrlBox.Color := EDITORSUBBACKCOLORLIGHT
    else
      FVertScrlBox.Color := EDITORSUBBACKCOLORDARK;
    {$ENDIF}


    //                  Axis Panel
    //**************************************************
    FXPanel := TTMSFNCEditorPanel.Create(AParent);
    FXPanel.PanelPosition := eppCenter;
    {$IFDEF FMXLIB}
    FXPanel.Align := TAlignLayout.Client;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanel.Align := alClient;
    {$ENDIF}
    FXPanel.Parent := AParent;

    if Axis = eatXAxis then
      txt := TranslateTextEx(sTMSFNCChartAxisEditorXAxis)
    else
      txt := TranslateTextEx(sTMSFNCChartAxisEditorYAxis);

    lbl1 := TLabel.Create(FXPanel);
    lbl1.Parent := FXPanel;
    lbl1.AutoSize := True;
    {$IFDEF FMXLIB}
    lbl1.Position.X := MIDLBLSPACE;
    lbl1.Position.Y := BIGHEIGHTSPAC;
    lbl1.Text := txt;
    lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
    lbl1.Font.Size := 18;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl1.Left := MIDLBLSPACE;
    lbl1.Top := BIGHEIGHTSPAC;
    lbl1.Caption := TranslateTextEx(sTMSFNCChartAxisEditorAppearance);
    lbl1.Font.Size := 15;
    {$ENDIF}
    lbl1.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl1);

    lbl2 := TLabel.Create(FXPanel);
    lbl2.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
    lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartAxisEditorPosition);
    lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := lbl1.Left + SMALLLBLSPACE;
    lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartAxisEditorPosition);
    {$ENDIF}
    lbl2.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl2);

    FTopLabel := TLabel.Create(FXPanel);
    FTopLabel.Parent := FXPanel;
    if FAxis = eatXAxis then
       txt := TranslateTextEx(sTMSFNCChartAxisEditorTop)
    else
      txt := TranslateTextEx(sTMSFNCChartAxisEditorLeft);
    {$IFDEF FMXLIB}
    FTopLabel.Position.X := lbl2.Position.X + MIDLBLSPACE;
    FTopLabel.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
    FTopLabel.Text := txt;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTopLabel.Left := lbl2.Left + MIDLBLSPACE;
    FTopLabel.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
    FTopLabel.Caption := txt;
    {$ENDIF}
    SetEditorLabelAppearance(FTopLabel);

    FXPanTopLeftCheck := TCheckBox.Create(FXPanel);
    FXPanTopLeftCheck.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanTopLeftCheck.Position.X := FTopLabel.Position.X + SMALLHORSPACE;
    FXPanTopLeftCheck.Position.Y := FTopLabel.Position.Y + (FTopLabel.Height - FXPanTopLeftCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanTopLeftCheck.Height := CHECKBOXSIZE;
    FXPanTopLeftCheck.Width := CHECKBOXSIZE;
    FXPanTopLeftCheck.Left := FTopLabel.Left + SMALLHORSPACE;
    FXPanTopLeftCheck.Top := FTopLabel.Top + (FTopLabel.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    lbl4 := TLabel.Create(FXPanel);
    lbl4.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := FTopLabel.Position.X;
    lbl4.Position.Y := FTopLabel.Position.Y + FTopLabel.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartAxisEditorCenter);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := FTopLabel.Left;
    lbl4.Top := FTopLabel.Top + FTopLabel.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartAxisEditorCenter);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FXPanCenterCheck := TCheckBox.Create(FXPanel);
    FXPanCenterCheck.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanCenterCheck.Position.X := FXPanTopLeftCheck.Position.X;
    FXPanCenterCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FXPanCenterCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanCenterCheck.Height := CHECKBOXSIZE;
    FXPanCenterCheck.Width := CHECKBOXSIZE;
    FXPanCenterCheck.Left := FXPanTopLeftCheck.Left;
    FXPanCenterCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    FBottomLabel := TLabel.Create(FXPanel);
    FBottomLabel.Parent := FXPanel;
    if FAxis = eatXAxis then
       txt := TranslateTextEx(sTMSFNCChartAxisEditorBottom)
    else
      txt := TranslateTextEx(sTMSFNCChartAxisEditorRight);
    {$IFDEF FMXLIB}
    FBottomLabel.Position.X := lbl4.Position.X;
    FBottomLabel.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    FBottomLabel.Text := txt;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FBottomLabel.Left := lbl4.Left;
    FBottomLabel.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    FBottomLabel.Caption := txt;
    {$ENDIF}
    SetEditorLabelAppearance(FBottomLabel);

    FXPanBottomRightCheck := TCheckBox.Create(FXPanel);
    FXPanBottomRightCheck.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanBottomRightCheck.Position.X := FXPanCenterCheck.Position.X;
    FXPanBottomRightCheck.Position.Y := FBottomLabel.Position.Y + (FBottomLabel.Height - FXPanBottomRightCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanBottomRightCheck.Height := CHECKBOXSIZE;
    FXPanBottomRightCheck.Width := CHECKBOXSIZE;
    FXPanBottomRightCheck.Left := FXPanCenterCheck.Left;
    FXPanBottomRightCheck.Top := FBottomLabel.Top + (FBottomLabel.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    lbl4 := TLabel.Create(FXPanel);
    lbl4.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := FBottomLabel.Position.X;
    lbl4.Position.Y := FBottomLabel.Position.Y + FBottomLabel.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartAxisEditorAutosize);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := FBottomLabel.Left;
    lbl4.Top := FBottomLabel.Top + FBottomLabel.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartAxisEditorAutosize);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FXPanAutoSizeCheck := TCheckBox.Create(FXPanel);
    FXPanAutoSizeCheck.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanAutoSizeCheck.Position.X := FXPanCenterCheck.Position.X;
    FXPanAutoSizeCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FXPanAutoSizeCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanAutoSizeCheck.Height := CHECKBOXSIZE;
    FXPanAutoSizeCheck.Width := CHECKBOXSIZE;
    FXPanAutoSizeCheck.Left := FXPanCenterCheck.Left;
    FXPanAutoSizeCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}


    FSizeLabel := TLabel.Create(FXPanel);
    FSizeLabel.Parent := FXPanel;
    if FAxis = eatXAxis then
      txt := TranslateTextEx(sTMSFNCChartAxisEditorHeight)
    else
      txt := TranslateTextEx(sTMSFNCChartAxisEditorWidth);
    {$IFDEF FMXLIB}
    FSizeLabel.Position.X := lbl4.Position.X;
    FSizeLabel.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    FSizeLabel.Text := txt;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FSizeLabel.Left := lbl4.Left;
    FSizeLabel.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    FSizeLabel.Caption := txt;
    {$ENDIF}
    SetEditorLabelAppearance(FSizeLabel);

    FXPanSize := TTMSFNCChartAxisEditorSpinEdit.Create(FXPanel);
    FXPanSize.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanSize.DecimalDigits := 1;
    FXPanSize.Position.X := FXPanCenterCheck.Position.X;
    FXPanSize.Position.Y := FSizeLabel.Position.Y + (FSizeLabel.Height - FXPanSize.Height)/2;
    FXPanSize.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanSize.Left := FXPanTopLeftCheck.Left;
    FXPanSize.Top := FSizeLabel.Top + (FSizeLabel.Height - FXPanSize.Height) div 2;
    {$ENDIF}
    FXPanSize.Width := LARGECONTROLWIDTH;

    lbl3 := TLabel.Create(FXPanel);
    lbl3.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := FSizeLabel.Position.X;
    lbl3.Position.Y := FSizeLabel.Position.Y + FSizeLabel.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAxisEditorBorder);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := FSizeLabel.Left;
    lbl3.Top := FSizeLabel.Top + FSizeLabel.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAxisEditorBorder);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FXPanBorderCheck := TCheckBox.Create(FXPanel);
    FXPanBorderCheck.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanBorderCheck.Position.X := lbl3.Position.X + SMALLHORSPACE;
    FXPanBorderCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FXPanBorderCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanBorderCheck.Height := CHECKBOXSIZE;
    FXPanBorderCheck.Width := CHECKBOXSIZE;
    FXPanBorderCheck.Left := lbl3.Left + SMALLHORSPACE;
    FXPanBorderCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    lbl4 := TLabel.Create(FXPanel);
    lbl4.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartAxisEditorLine);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartAxisEditorLine);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FXPanLineCheck := TCheckBox.Create(FXPanel);
    FXPanLineCheck.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanLineCheck.Position.X := FXPanCenterCheck.Position.X;
    FXPanLineCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FXPanLineCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanLineCheck.Height := CHECKBOXSIZE;
    FXPanLineCheck.Width := CHECKBOXSIZE;
    FXPanLineCheck.Left := FXPanTopLeftCheck.Left;
    FXPanLineCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    lbl3 := TLabel.Create(FXPanel);
    lbl3.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl4.Position.X;
    lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAxisEditorVisible);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAxisEditorVisible);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FXPanVisibleCheck := TCheckBox.Create(FXPanel);
    FXPanVisibleCheck.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanVisibleCheck.Position.X := FXPanCenterCheck.Position.X;
    FXPanVisibleCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FXPanVisibleCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanVisibleCheck.Height := CHECKBOXSIZE;
    FXPanVisibleCheck.Width := CHECKBOXSIZE;
    FXPanVisibleCheck.Left := FXPanTopLeftCheck.Left;
    FXPanVisibleCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    //GVH lbl3 to lbl4 and following
    lbl4 := TLabel.Create(FXPanel);
    lbl4.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartAxisEditorDisplayAtReference);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartAxisEditorDisplayAtReference);
    {$ENDIF}
    lbl4.Hint := TranslateTextEx(sTMSFNCChartAxisEditorRefHint);
    lbl4.ShowHint := True;
    SetEditorLabelAppearance(lbl4);

    FXPanRefCheck := TCheckBox.Create(FXPanel);
    FXPanRefCheck.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanRefCheck.Position.X := FXPanSize.Position.X + FXPanSize.Width - CHECKBOXSIZE;
    FXPanRefCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FXPanRefCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanRefCheck.Height := CHECKBOXSIZE;
    FXPanRefCheck.Width := CHECKBOXSIZE;
    FXPanRefCheck.Left := FXPanSize.Left + FXPanSize.Width - FXPanRefCheck.Width;
    FXPanRefCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}
    FXPanRefCheck.Hint := TranslateTextEx(sTMSFNCChartAxisEditorRefHint);
    FXPanRefCheck.ShowHint := True;

    lbl3 := TLabel.Create(FXPanel);
    lbl3.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl4.Position.X;
    lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAxisEditorReference);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAxisEditorReference);
    {$ENDIF}
    lbl3.Hint := TranslateTextEx(sTMSFNCChartAxisEditorRefHint);
    lbl3.ShowHint := True;
    SetEditorLabelAppearance(lbl3);

    FXPanAppRef := TTMSFNCChartAxisEditorSpinEdit.Create(FXPanel);
    FXPanAppRef.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanAppRef.DecimalDigits := 1;
    FXPanAppRef.Position.X := FXPanCenterCheck.Position.X;
    FXPanAppRef.Position.Y := lbl3.Position.Y + (lbl3.Height - FXPanAppRef.Height)/2;
    FXPanAppRef.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanAppRef.Left := FXPanCenterCheck.Left;
    FXPanAppRef.Top := lbl3.Top + (lbl3.Height - FXPanAppRef.Height) div 2;
    {$ENDIF}
    FXPanAppRef.Hint := TranslateTextEx(sTMSFNCChartAxisEditorRefHint);
    FXPanAppRef.ShowHint := True;
    FXPanAppRef.Width := LARGECONTROLWIDTH;

    lbl3 := TLabel.Create(FXPanel);
    lbl3.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := FXPanSize.Position.X + FXPanSize.Width + BIGLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAxisEditorFill);
    lbl3.StyledSettings := lbl3.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := FXPanSize.Left + FXPanSize.Width + BIGLBLSPACE;
    lbl3.Top := lbl2.Top;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAxisEditorFill);
    {$ENDIF}
    lbl3.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl3);

    lbl2 := TLabel.Create(FXPanel);
    lbl2.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl2.Position.X := lbl3.Position.X + MIDLBLSPACE;
    lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + SMALLHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartAxisEditorColor);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := lbl3.Left + MIDLBLSPACE;
    lbl2.Top := lbl3.Top + lbl3.Height + SMALLHEIGHTSPAC;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartAxisEditorColor);
    {$ENDIF}
    SetEditorLabelAppearance(lbl2);

    FXPanFillCol1 := TTMSFNCChartAxisEditorColorCombo.Create(FXPanel);
    FXPanFillCol1.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanFillCol1.Position.X := lbl2.Position.X + SMALLHORSPACE;
    FXPanFillCol1.Position.Y := lbl2.Position.Y + (lbl2.Height - FXPanFillCol1.Height)/2;
    FXPanFillCol1.Width := SMALLCONTROLWIDTH;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FXPanFillCol1);
    FXPanFillCol1.Width := LARGECONTROLWIDTH;
    FXPanFillCol1.Left := lbl2.Left + SMALLHORSPACE;
    FXPanFillCol1.Top := lbl2.Top + (lbl2.Height - FXPanFillCol1.Height) div 2;
    {$ENDIF}


    {$IFDEF CMNWEBLIB}
    lbl5 := TLabel.Create(FXPanel);
    lbl5.Parent := FXPanel;
    lbl5.Left := lbl2.Left;
    lbl5.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
    lbl5.Caption := TranslateTextEx(sTMSFNCChartAxisEditorColorTo);
    SetEditorLabelAppearance(lbl5);
    {$ENDIF}

    FXPanFillCol2 := TTMSFNCChartAxisEditorColorCombo.Create(FXPanel);
    FXPanFillCol2.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanFillCol2.Position.X := FXPanFillCol1.Position.X + FXPanFillCol1.Width + SMALLLBLSPACE;
    FXPanFillCol2.Position.Y := FXPanFillCol1.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FXPanFillCol2);
    FXPanFillCol2.Left := FXPanFillCol1.Left;
    FXPanFillCol2.Top := lbl5.Top + (lbl5.Height - FXPanFillCol2.Height) div 2;
    {$ENDIF}
    FXPanFillCol2.Width := FXPanFillCol1.Width;

    lbl4 := TLabel.Create(FXPanel);
    lbl4.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl2.Position.X;
    lbl4.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartAxisEditorKind);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl2.Left;
    lbl4.Top := lbl5.Top + lbl5.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartAxisEditorKind);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FXPanFillKind := TTMSFNCChartAxisEditorComboBox.Create(FXPanel);
    FXPanFillKind.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanFillKind.Position.X := FXPanFillCol1.Position.X;
    FXPanFillKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FXPanFillKind.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanFillKind.Left := FXPanFillCol1.Left;
    FXPanFillKind.Top := lbl4.Top + (lbl4.Height - FXPanFillKind.Height) div 2;
    {$ENDIF}
    FXPanFillKind.Items.Add('None');
    FXPanFillKind.Items.Add('Solid');
    FXPanFillKind.Items.Add('Gradient');
    FXPanFillKind.Width := LARGECONTROLWIDTH;

    lbl5 := TLabel.Create(FXPanel);
    lbl5.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl5.Position.X := lbl4.Position.X;
    lbl5.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl5.Text := TranslateTextEx(sTMSFNCChartAxisEditorGradient);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl5.Left := lbl4.Left;
    lbl5.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl5.Caption := TranslateTextEx(sTMSFNCChartAxisEditorGradient);
    {$ENDIF}
    SetEditorLabelAppearance(lbl5);

    FXPanGradientKind := TTMSFNCChartAxisEditorComboBox.Create(FXPanel);
    FXPanGradientKind.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanGradientKind.Position.X := FXPanFillCol1.Position.X;
    FXPanGradientKind.Position.Y := lbl5.Position.Y + (lbl5.Height - FXPanGradientKind.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanGradientKind.Left := FXPanFillCol1.Left;
    FXPanGradientKind.Top := lbl5.Top + (lbl5.Height - FXPanGradientKind.Height) div 2;
    {$ENDIF}
    FXPanGradientKind.Items.Add('Horizontal');
    FXPanGradientKind.Items.Add('Vertical');
    FXPanGradientKind.Width := LARGECONTROLWIDTH;

    {$IFDEF FMXLIB}
    lbl2 := TLabel.Create(FXPanel);
    lbl2.Parent := FXPanel;
    lbl2.Position.X := lbl5.Position.X;
    lbl2.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartAxisEditorOpacity);
    SetEditorLabelAppearance(lbl2);

    FXPanFillOpacity := TTMSFNCChartAxisEditorAlphaTrackBar.Create(FXPanel);
    FXPanFillOpacity.Parent := FXPanel;
    FXPanFillOpacity.Position.X := FXPanFillKind.Position.X;
    FXPanFillOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FXPanFillOpacity.Height)/2;
    FXPanFillOpacity.Width := LARGECONTROLWIDTH;
    {$ENDIF}

    lbl2 := TLabel.Create(FXPanel);
    lbl2.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl2.Position.X := FXPanFillOpacity.Position.X + FXPanFillOpacity.Width + BIGLBLSPACE;
    lbl2.Position.Y := lbl3.Position.Y;
    lbl2.Text := TranslateTextEx(sTMSFNCChartAxisEditorStroke);
    lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := FXPanFillKind.Left + FXPanFillKind.Width + BIGLBLSPACE;
    lbl2.Top := lbl3.Top;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartAxisEditorStroke);
    {$ENDIF}
    lbl2.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl2);

    lbl3 := TLabel.Create(FXPanel);
    lbl3.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAxisEditorColor);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl2.Left + MIDLBLSPACE;
    lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAxisEditorColor);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FXPanStrokeCol := TTMSFNCChartAxisEditorColorCombo.Create(FXPanel);
    FXPanStrokeCol.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanStrokeCol.Position.X := lbl3.Position.X + SMALLHORSPACE;
    FXPanStrokeCol.Position.Y := lbl3.Position.Y + (lbl3.Height - FXPanStrokeCol.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FXPanStrokeCol);
    FXPanStrokeCol.Left := lbl3.Left + SMALLHORSPACE;
    FXPanStrokeCol.Top := lbl3.Top + (lbl3.Height - FXPanStrokeCol.Height) div 2;
    {$ENDIF}
    FXPanStrokeCol.Width := FXPanFillCol1.Width;

    lbl4 := TLabel.Create(FXPanel);
    lbl4.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartAxisEditorKind);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartAxisEditorKind);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FXPanStrokeKind := TTMSFNCChartAxisEditorComboBox.Create(FXPanel);
    FXPanStrokeKind.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanStrokeKind.Position.X := FXPanStrokeCol.Position.X;
    FXPanStrokeKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FXPanStrokeKind.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanStrokeKind.Left := FXPanStrokeCol.Left;
    FXPanStrokeKind.Top := lbl4.Top + (lbl4.Height - FXPanStrokeKind.Height) div 2;
    {$ENDIF}
    FXPanStrokeKind.Items.Add('None');
    FXPanStrokeKind.Items.Add('Solid');
    FXPanStrokeKind.Items.Add('Dash');
    FXPanStrokeKind.Items.Add('Dot');
    FXPanStrokeKind.Items.Add('DashDot');
    FXPanStrokeKind.Items.Add('DashDotDot');
    FXPanStrokeKind.Width := LARGECONTROLWIDTH;

    {$IFDEF FMXLIB}
    lbl2 := TLabel.Create(FXPanel);
    lbl2.Parent := FXPanel;
    lbl2.Position.X := lbl4.Position.X;
    lbl2.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartAxisEditorOpacity);
    SetEditorLabelAppearance(lbl2);

    FXPanStrokeOpacity := TTMSFNCChartAxisEditorAlphaTrackBar.Create(FXPanel);
    FXPanStrokeOpacity.Parent := FXPanel;
    FXPanStrokeOpacity.Position.X := FXPanStrokeKind.Position.X;
    FXPanStrokeOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FXPanStrokeOpacity.Height)/2;
    FXPanStrokeOpacity.Width := LARGECONTROLWIDTH;
    {$ENDIF}

    lbl3 := TLabel.Create(FXPanel);
    lbl3.Parent := FXPanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartAxisEditorWidth);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartAxisEditorWidth);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FXPanStrokeWidth := TTMSFNCChartAxisEditorSpinEdit.Create(FXPanel);
    FXPanStrokeWidth.Parent := FXPanel;
    {$IFDEF FMXLIB}
    FXPanStrokeWidth.Min := 0;
    FXPanStrokeWidth.DecimalDigits := 1;
    FXPanStrokeWidth.Position.X := FXPanStrokeOpacity.Position.X;
    FXPanStrokeWidth.Position.Y := lbl3.Position.Y + (lbl3.Height - FXPanStrokeWidth.Height)/2;
    FXPanStrokeWidth.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FXPanStrokeWidth.MinValue := 0;
    FXPanStrokeWidth.Left := FXPanStrokeKind.Left;
    FXPanStrokeWidth.Top := lbl3.Top + (lbl3.Height - FXPanStrokeWidth.Height) div 2;
    {$ENDIF}
    FXPanStrokeWidth.Width := LARGECONTROLWIDTH;


    //                     Bottom Panel
    //-------------------------------------------------------

    CreateBottomPanel(AParent);

    Initialize;
    SetAppearance;
  end;
end;

procedure TTMSFNCChartAxisEditor.DoButtonOKClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if SaveChartMessage then
    {$ENDIF}
      frm.ModalResult := mrOk;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrOk;
    {$ENDIF}
  end;
end;

procedure TTMSFNCChartAxisEditor.DoAxisAppFillChange(Sender: TObject);
begin
  if FAxis = eatXAxis then
  begin
    FChart.XAxis.Fill.Kind := TTMSFNCGraphicsFillKind(FXPanFillKind.ItemIndex);
    FChart.XAxis.Fill.GradientOrientation := TTMSFNCGraphicsFillOrientation(FXPanGradientKind.ItemIndex);
    {$IFDEF FMXLIB}
    FChart.XAxis.Fill.Color := FXPanFillCol1.Color;
    FChart.XAxis.Fill.ColorTo := FXPanFillCol2.Color;
    FChart.XAxis.Fill.Opacity := FXPanFillOpacity.Value;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FChart.XAxis.Fill.Color := FXPanFillCol1.Selected;
    FChart.XAxis.Fill.ColorTo := FXPanFillCol2.Selected;
    {$ENDIF}
  end
  else
  begin
    FChart.YAxis.Fill.Kind := TTMSFNCGraphicsFillKind(FXPanFillKind.ItemIndex);
    FChart.YAxis.Fill.GradientOrientation := TTMSFNCGraphicsFillOrientation(FXPanGradientKind.ItemIndex);
    {$IFDEF FMXLIB}
    FChart.YAxis.Fill.Color := FXPanFillCol1.Color;
    FChart.YAxis.Fill.ColorTo := FXPanFillCol2.Color;
    FChart.YAxis.Fill.Opacity := FXPanFillOpacity.Value;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FChart.YAxis.Fill.Color := FXPanFillCol1.Selected;
    FChart.YAxis.Fill.ColorTo := FXPanFillCol2.Selected;
    {$ENDIF}
  end;
  FModified := True;
end;

procedure TTMSFNCChartAxisEditor.DoAxisAppPosAxisChange(Sender: TObject);
begin
  if FAxis = eatXAxis then
  begin
    {$IFDEF FMXLIB}
    if FXPanTopLeftCheck.IsChecked then
    {$ENDIF}
    {$IFNDEF FMXLIB}
    if FXPanTopLeftCheck.Checked then
    {$ENDIF}
      FChart.XAxis.Positions := FChart.XAxis.Positions + [xpTop]
    else
      FChart.XAxis.Positions := FChart.XAxis.Positions - [xpTop];

    {$IFDEF FMXLIB}
    if FXPanCenterCheck.IsChecked then
    {$ENDIF}
    {$IFNDEF FMXLIB}
    if FXPanCenterCheck.Checked then
    {$ENDIF}
      FChart.XAxis.Positions := FChart.XAxis.Positions + [xpCenter]
    else
      FChart.XAxis.Positions := FChart.XAxis.Positions - [xpCenter];

    {$IFDEF FMXLIB}
    if FXPanBottomRightCheck.IsChecked then
    {$ENDIF}
    {$IFNDEF FMXLIB}
    if FXPanBottomRightCheck.Checked then
    {$ENDIF}
      FChart.XAxis.Positions := FChart.XAxis.Positions + [xpBottom]
    else
      FChart.XAxis.Positions := FChart.XAxis.Positions - [xpBottom];
  end
  else
  begin
    {$IFDEF FMXLIB}
    if FXPanTopLeftCheck.IsChecked then
    {$ENDIF}
    {$IFNDEF FMXLIB}
    if FXPanTopLeftCheck.Checked then
    {$ENDIF}
      FChart.YAxis.Positions := FChart.YAxis.Positions + [ypLeft]
    else
      FChart.YAxis.Positions := FChart.YAxis.Positions - [ypLeft];

    {$IFDEF FMXLIB}
    if FXPanCenterCheck.IsChecked then
    {$ENDIF}
    {$IFNDEF FMXLIB}
    if FXPanCenterCheck.Checked then
    {$ENDIF}
      FChart.YAxis.Positions := FChart.YAxis.Positions + [ypCenter]
    else
      FChart.YAxis.Positions := FChart.YAxis.Positions - [ypCenter];

    {$IFDEF FMXLIB}
    if FXPanBottomRightCheck.IsChecked then
    {$ENDIF}
    {$IFNDEF FMXLIB}
    if FXPanBottomRightCheck.Checked then
    {$ENDIF}
      FChart.YAxis.Positions := FChart.YAxis.Positions + [ypRight]
    else
      FChart.YAxis.Positions := FChart.YAxis.Positions - [ypRight];
  end;

  {$IFDEF FMXLIB}
  FXPanRefCheck.Enabled := FXPanCenterCheck.IsChecked;
  FXPanAppRef.Enabled := FXPanCenterCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FXPanRefCheck.Enabled := FXPanCenterCheck.Checked;
  FXPanAppRef.Enabled := FXPanCenterCheck.Checked;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartAxisEditor.DoAxisAppPosChange(Sender: TObject);
begin
  if FAxis = eatXAxis then
  begin
    FChart.XAxis.Height := FXPanSize.Value;
    {$IFDEF FMXLIB}
    FChart.XAxis.Border := FXPanBorderCheck.IsChecked;
    FChart.XAxis.Line := FXPanLineCheck.IsChecked;
    FChart.XAxis.Visible := FXPanVisibleCheck.IsChecked;
    FChart.XAxis.AutoSize := FXPanAutoSizeCheck.IsChecked;
    FChart.XAxis.DisplayAtReferenceValue := FXPanRefCheck.IsChecked;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FChart.XAxis.Border := FXPanBorderCheck.Checked;
    FChart.XAxis.Line := FXPanLineCheck.Checked;
    FChart.XAxis.Visible := FXPanVisibleCheck.Checked;
    FChart.XAxis.AutoSize := FXPanAutoSizeCheck.Checked;
    FChart.XAxis.DisplayAtReferenceValue := FXPanRefCheck.Checked;
    {$ENDIF}
    FChart.XAxis.ReferenceValue := FXPanAppRef.Value;
  end
  else
  begin
    FChart.YAxis.Width := FXPanSize.Value;
    {$IFDEF FMXLIB}
    FChart.YAxis.Border := FXPanBorderCheck.IsChecked;
    FChart.YAxis.Line := FXPanLineCheck.IsChecked;
    FChart.YAxis.Visible := FXPanVisibleCheck.IsChecked;
    FChart.YAxis.AutoSize := FXPanAutoSizeCheck.IsChecked;
    FChart.YAxis.DisplayAtReferenceValue := FXPanRefCheck.IsChecked;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FChart.YAxis.Border := FXPanBorderCheck.Checked;
    FChart.YAxis.Line := FXPanLineCheck.Checked;
    FChart.YAxis.Visible := FXPanVisibleCheck.Checked;
    FChart.YAxis.AutoSize := FXPanAutoSizeCheck.Checked;
    FChart.YAxis.DisplayAtReferenceValue := FXPanRefCheck.Checked;
    {$ENDIF}
    FChart.YAxis.ReferenceValue := FXPanAppRef.Value;
  end;

  {$IFDEF FMXLIB}
  FXPanSize.Enabled := not FXPanAutoSizeCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FXPanSize.Enabled := not FXPanAutoSizeCheck.Checked;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartAxisEditor.DoAxisAppStrokeChange(Sender: TObject);
begin
  if FAxis = eatXAxis then
  begin
    FChart.XAxis.Stroke.Kind := TTMSFNCGraphicsStrokeKind(FXPanStrokeKind.ItemIndex);
    {$IFDEF FMXLIB}
    FChart.XAxis.Stroke.Color := FXPanStrokeCol.Color;
    FChart.XAxis.Stroke.Opacity := FXPanStrokeOpacity.Value;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FChart.XAxis.Stroke.Color := FXPanStrokeCol.Selected;
    {$ENDIF}
    FChart.XAxis.Stroke.Width := FXPanStrokeWidth.Value;
  end
  else
  begin
    FChart.YAxis.Stroke.Kind := TTMSFNCGraphicsStrokeKind(FXPanStrokeKind.ItemIndex);
    {$IFDEF FMXLIB}
    FChart.YAxis.Stroke.Color := FXPanStrokeCol.Color;
    FChart.YAxis.Stroke.Opacity := FXPanStrokeOpacity.Value;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FChart.YAxis.Stroke.Color := FXPanStrokeCol.Selected;
    {$ENDIF}
    FChart.YAxis.Stroke.Width := FXPanStrokeWidth.Value;
  end;

  FModified := True;
end;

procedure TTMSFNCChartAxisEditor.DoButtonCancelClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if CancelChartMessage then
    {$ENDIF}
      frm.ModalResult := mrCancel;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrCancel;
    {$ENDIF}
  end;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartAxisEditor.ApplyCSS(ACSS: string);
begin
//  FButtonOK.ElementClassName := 'IDEButton IDEFont';
//  FButtonCancel.ElementClassName := 'IDEButton IDEFont';
//  FButtonOpen.ElementClassName := 'IDEButton IDEFont';
//  FButtonClear.ElementClassName := 'IDEButton IDEFont';
//
//  FTopPanel.ElementClassName := 'IDEBkg';
//  FPanel.ElementClassName := 'IDEBkg';
end;
{$ENDIF}

function TTMSFNCChartAxisEditor.CancelChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartAxisEditorCancelChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

procedure TTMSFNCChartAxisEditor.ClearEvents;
begin
  FXPanSize.OnChange := nil;
  FXPanAppRef.OnChange := nil;


  FXPanFillKind.OnChange := nil;
  FXPanGradientKind.OnChange := nil;

  FXPanStrokeWidth.OnChange := nil;
  FXPanStrokeKind.OnChange := nil;

  {$IFDEF WEBLIB}
  FXPanFillCol1.OnSelect := nil;
  FXPanFillCol2.OnSelect := nil;
  FXPanStrokeCol.OnSelect := nil;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FXPanFillCol1.OnChange := nil;
  FXPanFillCol2.OnChange := nil;
  FXPanStrokeCol.OnChange := nil;
  {$ENDIF}

  {$IFDEF FMXLIB}
  FXPanTopLeftCheck.OnChange := nil;
  FXPanCenterCheck.OnChange := nil;
  FXPanBottomRightCheck.OnChange := nil;
  FXPanBorderCheck.OnChange := nil;
  FXPanLineCheck.OnChange := nil;
  FXPanVisibleCheck.OnChange := nil;
  FXPanAutoSizeCheck.OnChange := nil;
  FXPanRefCheck.OnChange := nil;

  FXPanFillOpacity.OnChange := nil;
  FXPanStrokeOpacity.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FXPanTopLeftCheck.OnClick := nil;
  FXPanCenterCheck.OnClick := nil;
  FXPanBottomRightCheck.OnClick := nil;
  FXPanBorderCheck.OnClick := nil;
  FXPanLineCheck.OnClick := nil;
  FXPanVisibleCheck.OnClick := nil;
  FXPanAutoSizeCheck.OnClick := nil;
  FXPanRefCheck.OnClick := nil;
  {$ENDIF}
end;

constructor TTMSFNCChartAxisEditor.Create(AOwner: TComponent; AAxis: TTMSFNCChartAxisEditorAxisType = eatXAxis);
begin
  inherited Create(AOwner);
  FAxis := AAxis;
end;

procedure TTMSFNCChartAxisEditor.CreateBottomPanel(AParent: TTMSFNCChartAxisEditorParent);
begin
  FPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FPanel.Align := TAlignLayout.Bottom;
  FPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPanel.PanelPosition := eppCenter;
  FPanel.Align := alBottom;
  {$ENDIF}
  FPanel.Parent := AParent;

  FPanel.Height := 37;

  FButtonCancel := TTMSFNCEditorButton.Create(FPanel);
//    FButtonCancel.ModalResult := mrCancel;
  FButtonCancel.Parent := FPanel;
  FButtonCancel.Text := TranslateTextEx(sTMSFNCChartAxisEditorCancel);
  {$IFDEF FMXLIB}
  FButtonCancel.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonCancel.Align := alRight;
  FButtonCancel.Left := 99;
  {$IFDEF VCLWEBLIB}
  FButtonCancel.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonCancel.BorderSpacing.Right := 5;
  FButtonCancel.BorderSpacing.Top := 5;
  FButtonCancel.BorderSpacing.Bottom := 5;
  FButtonCancel.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonCancel.Margins.Right := 5;
  FButtonCancel.Margins.Top := 5;
  FButtonCancel.Margins.Bottom := 5;
  FButtonCancel.Margins.Left := 5;
  {$ENDIF}
  FButtonCancel.OnClick := @DoButtonCancelClick;

  FButtonOK := TTMSFNCEditorButton.Create(FPanel);
//    FButtonOK.ModalResult := mrOk;
  FButtonOK.Parent := FPanel;
  FButtonOK.Text := TranslateTextEx(sTMSFNCChartAxisEditorOK);
  {$IFDEF FMXLIB}
  FButtonOk.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonOk.Align := alRight;
  FButtonOk.Left := 98;
  {$IFDEF VCLWEBLIB}
  FButtonOK.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonOK.Margins.Right := 0;
  FButtonOK.Margins.Top := 5;
  FButtonOK.Margins.Bottom := 5;
  FButtonOK.Margins.Left := 5;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonOK.BorderSpacing.Right := 0;
  FButtonOK.BorderSpacing.Top := 5;
  FButtonOK.BorderSpacing.Bottom := 5;
  FButtonOK.BorderSpacing.Left := 5;
  {$ENDIF}
  FButtonOK.OnClick := @DoButtonOKClick;
end;

destructor TTMSFNCChartAxisEditor.Destroy;
begin
  FBitmapEditor.Free;
  inherited;
end;

{$IFNDEF FMXLIB}
procedure TTMSFNCChartAxisEditor.DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
{$IFDEF FMXLIB}
procedure TTMSFNCChartAxisEditor.DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
begin
  inherited;

  if Key = KEY_ESCAPE then
    DoButtonCancelClick(Self)
  else if Key = KEY_RETURN then
    DoButtonOKClick(Self);
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartAxisEditor.Execute(AProc: TModalResultProc = nil);
{$ELSE}
function TTMSFNCChartAxisEditor.Execute: TModalResult;
{$ENDIF}
begin
  if not Assigned(Chart) then
  begin
    raise Exception.Create('No chart was assigned to the editor!');
    Exit;
  end;

  {$IFDEF WEBLIB}
  frm := TTMSFNCChartAxisEditorForm.CreateDialogNew(Self, 'Chart Axis Editor');
  {$ELSE}
  frm := TTMSFNCChartAxisEditorForm.CreateNew(Application);
  frm.Caption := 'Chart Axis Editor';
  frm.BorderIcons := [TBorderIcon.biSystemMenu, TBorderIcon.biMinimize];
  {$ENDIF}

  FCopyChart := TTMSFNCChart.Create(frm);
  FCopyChart.Assign(Chart);

  frm.Width := 730;
  {$IFDEF VCLLIB}
  frm.Height := 540;
  {$ENDIF}
  {$IFNDEF VCLLIB}
  frm.Height := 500;
  {$ENDIF}
  {$IFDEF FMXLIB}
  frm.Position := TFormPosition.ScreenCenter;
  frm.Fill.Kind := TBrushKind.Solid;
  if IsLightTheme then
    frm.Fill.Color := EDITORSUBBACKCOLORLIGHT
  else
    frm.Fill.Color := EDITORSUBBACKCOLORDARK;
  {$ENDIF}
  {$IFDEF CMNLIB}
  frm.KeyPreview := True;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  frm.OnKeyDown := DoFormKeyDown;
  {$ENDIF}
  {$IFDEF LCLLIB}
  frm.OnKeyDown := @DoFormKeyDown;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  frm.Position := poScreenCenter;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  BuildEditor(frm);
  frm.ActiveControl := FXPanel;
  {$ENDIF}
  TTMSFNCUtils.ScaleForCurrentDPI(frm);
  {$IFNDEF WEBLIB}
  Result := frm.ShowModal;
  if (Result <> mrOk) and Assigned(Chart) then
  begin
    Chart.Assign(nil);
    Chart.BeginUpdate;
    Chart.Assign(FCopyChart);
    Chart.EndUpdate;
    FCopyChart := nil;
  end;
  frm.Free;
  {$ELSE}
  frm.ShowModal(
  procedure(AResult: TModalResult)
  begin
    if (AResult <> mrOk) and Assigned(Chart) then
    begin
      Chart.Assign(nil);
      Chart.BeginUpdate;
      Chart.Assign(FCopyChart);
      Chart.EndUpdate;
      FCopyChart := nil;
    end;
    frm := nil;
    if Assigned(AProc) then
      AProc(AResult);
  end);
  {$ENDIF}
end;

function TTMSFNCChartAxisEditor.GetDocURL: string;
begin
  Result := TTMSFNCBaseDocURL + 'tmsfncchart';
end;

function TTMSFNCChartAxisEditor.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

function TTMSFNCChartAxisEditor.GetTipsURL: string;
begin
  Result := 'https://www.tmssoftware.com/site/tmsfncchart.asp?s=faq';
end;

procedure TTMSFNCChartAxisEditor.Initialize;
begin
  if FAxis = eatXAxis then
  begin
    {$IFDEF FMXLIB}
    FXPanTopLeftCheck.IsChecked := xpTop in FChart.XAxis.Positions;
    FXPanCenterCheck.IsChecked := xpCenter in FChart.XAxis.Positions;
    FXPanBottomRightCheck.IsChecked := xpBottom in FChart.XAxis.Positions;
    FXPanBorderCheck.IsChecked := FChart.XAxis.Border;
    FXPanLineCheck.IsChecked := FChart.XAxis.Line;
    FXPanVisibleCheck.IsChecked := FChart.XAxis.Visible;
    FXPanAutoSizeCheck.IsChecked := FChart.XAxis.AutoSize;
    FXPanRefCheck.IsChecked := FChart.XAxis.DisplayAtReferenceValue;
    FXPanSize.Value := FChart.XAxis.Height;
    FXPanAppRef.Value := FChart.XAxis.ReferenceValue;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXPanTopLeftCheck.Checked := xpTop in FChart.XAxis.Positions;
    FXPanCenterCheck.Checked := xpCenter in FChart.XAxis.Positions;
    FXPanBottomRightCheck.Checked := xpBottom in FChart.XAxis.Positions;
    FXPanBorderCheck.Checked := FChart.XAxis.Border;
    FXPanLineCheck.Checked := FChart.XAxis.Line;
    FXPanVisibleCheck.Checked := FChart.XAxis.Visible;
    FXPanAutoSizeCheck.Checked := FChart.XAxis.AutoSize;
    FXPanRefCheck.Checked := FChart.XAxis.DisplayAtReferenceValue;
    FXPanSize.Value := Trunc(FChart.XAxis.Height);
    FXPanAppRef.Value := Trunc(FChart.XAxis.ReferenceValue);
    {$ENDIF}

    FXPanFillKind.ItemIndex := Integer(FChart.XAxis.Fill.Kind);
    FXPanGradientKind.ItemIndex := Integer(FChart.XAxis.Fill.GradientOrientation);
    {$IFDEF FMXLIB}
    FXPanFillCol1.Color := FChart.XAxis.Fill.Color;
    FXPanFillCol2.Color := FChart.XAxis.Fill.ColorTo;
    FXPanFillOpacity.Value := FChart.XAxis.Fill.Opacity;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXPanFillCol1.Selected := FChart.XAxis.Fill.Color;
    FXPanFillCol2.Selected := FChart.XAxis.Fill.ColorTo;
    {$ENDIF}

    FXPanStrokeKind.ItemIndex := Integer(FChart.XAxis.Stroke.Kind);
    {$IFDEF FMXLIB}
    FXPanStrokeCol.Color := FChart.XAxis.Stroke.Color;
    FXPanStrokeOpacity.Value := FChart.XAxis.Stroke.Opacity;
    FXPanStrokeWidth.Value := FChart.XAxis.Stroke.Width;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXPanStrokeCol.Selected := FChart.XAxis.Stroke.Color;
    FXPanStrokeWidth.Value := Trunc(FChart.XAxis.Stroke.Width);
    {$ENDIF}
  end
  else
  begin
    {$IFDEF FMXLIB}
    FXPanTopLeftCheck.IsChecked := ypLeft in FChart.YAxis.Positions;
    FXPanCenterCheck.IsChecked := ypCenter in FChart.YAxis.Positions;
    FXPanBottomRightCheck.IsChecked := ypRight in FChart.YAxis.Positions;
    FXPanBorderCheck.IsChecked := FChart.YAxis.Border;
    FXPanLineCheck.IsChecked := FChart.YAxis.Line;
    FXPanVisibleCheck.IsChecked := FChart.YAxis.Visible;
    FXPanAutoSizeCheck.IsChecked := FChart.YAxis.AutoSize;
    FXPanRefCheck.IsChecked := FChart.YAxis.DisplayAtReferenceValue;
    FXPanSize.Value := FChart.YAxis.Width;
    FXPanAppRef.Value := FChart.YAxis.ReferenceValue;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXPanTopLeftCheck.Checked := ypLeft in FChart.YAxis.Positions;
    FXPanCenterCheck.Checked := ypCenter in FChart.YAxis.Positions;
    FXPanBottomRightCheck.Checked := ypRight in FChart.YAxis.Positions;
    FXPanBorderCheck.Checked := FChart.YAxis.Border;
    FXPanLineCheck.Checked := FChart.YAxis.Line;
    FXPanVisibleCheck.Checked := FChart.YAxis.Visible;
    FXPanAutoSizeCheck.Checked := FChart.YAxis.AutoSize;
    FXPanRefCheck.Checked := FChart.YAxis.DisplayAtReferenceValue;
    FXPanSize.Value := Trunc(FChart.YAxis.Width);
    FXPanAppRef.Value := Trunc(FChart.YAxis.ReferenceValue);
    {$ENDIF}

    FXPanFillKind.ItemIndex := Integer(FChart.YAxis.Fill.Kind);
    FXPanGradientKind.ItemIndex := Integer(FChart.YAxis.Fill.GradientOrientation);
    {$IFDEF FMXLIB}
    FXPanFillCol1.Color := FChart.YAxis.Fill.Color;
    FXPanFillCol2.Color := FChart.YAxis.Fill.ColorTo;
    FXPanFillOpacity.Value := FChart.YAxis.Fill.Opacity;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXPanFillCol1.Selected := FChart.YAxis.Fill.Color;
    FXPanFillCol2.Selected := FChart.YAxis.Fill.ColorTo;
    {$ENDIF}

    FXPanStrokeKind.ItemIndex := Integer(FChart.YAxis.Stroke.Kind);
    {$IFDEF FMXLIB}
    FXPanStrokeCol.Color := FChart.YAxis.Stroke.Color;
    FXPanStrokeOpacity.Value := FChart.YAxis.Stroke.Opacity;
    FXPanStrokeWidth.Value := FChart.YAxis.Stroke.Width;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXPanStrokeCol.Selected := FChart.YAxis.Stroke.Color;
    FXPanStrokeWidth.Value := Trunc(FChart.YAxis.Stroke.Width);
    {$ENDIF}
  end;

  {$IFDEF FMXLIB}
  FXPanSize.Enabled := not FXPanAutoSizeCheck.IsChecked;
  FXPanRefCheck.Enabled := FXPanCenterCheck.IsChecked;
  FXPanAppRef.Enabled := FXPanCenterCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FXPanSize.Enabled := not FXPanAutoSizeCheck.Checked;
  FXPanRefCheck.Enabled := FXPanCenterCheck.Checked;
  FXPanAppRef.Enabled := FXPanCenterCheck.Checked;
  {$ENDIF}

  FXPanSize.OnChange := @DoAxisAppPosChange;
  FXPanAppRef.OnChange := @DoAxisAppPosChange;

  FXPanFillKind.OnChange := @DoAxisAppFillChange;
  FXPanGradientKind.OnChange := @DoAxisAppFillChange;

  FXPanStrokeWidth.OnChange := @DoAxisAppStrokeChange;
  FXPanStrokeKind.OnChange := @DoAxisAppStrokeChange;

  {$IFDEF WEBLIB}
  FXPanFillCol1.OnSelect := DoAxisAppFillChange;
  FXPanFillCol2.OnSelect := DoAxisAppFillChange;
  FXPanStrokeCol.OnSelect := DoAxisAppStrokeChange;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FXPanFillCol1.OnChange := @DoAxisAppFillChange;
  FXPanFillCol2.OnChange := @DoAxisAppFillChange;
  FXPanStrokeCol.OnChange := @DoAxisAppStrokeChange;
  {$ENDIF}

  {$IFDEF FMXLIB}
  FXPanTopLeftCheck.OnChange := @DoAxisAppPosAxisChange;
  FXPanCenterCheck.OnChange := @DoAxisAppPosAxisChange;
  FXPanBottomRightCheck.OnChange := @DoAxisAppPosAxisChange;
  FXPanBorderCheck.OnChange := @DoAxisAppPosChange;
  FXPanLineCheck.OnChange := @DoAxisAppPosChange;
  FXPanVisibleCheck.OnChange := @DoAxisAppPosChange;
  FXPanAutoSizeCheck.OnChange := @DoAxisAppPosChange;
  FXPanRefCheck.OnChange := @DoAxisAppPosChange;

  FXPanFillOpacity.OnChange := @DoAxisAppFillChange;
  FXPanStrokeOpacity.OnChange := @DoAxisAppStrokeChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FXPanTopLeftCheck.OnClick := @DoAxisAppPosAxisChange;
  FXPanCenterCheck.OnClick := @DoAxisAppPosAxisChange;
  FXPanBottomRightCheck.OnClick := @DoAxisAppPosAxisChange;
  FXPanBorderCheck.OnClick := @DoAxisAppPosChange;
  FXPanLineCheck.OnClick := @DoAxisAppPosChange;
  FXPanVisibleCheck.OnClick := @DoAxisAppPosChange;
  FXPanAutoSizeCheck.OnClick := @DoAxisAppPosChange;
  FXPanRefCheck.OnClick := @DoAxisAppPosChange;
  {$ENDIF}
end;

function TTMSFNCChartAxisEditor.SaveChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartAxisEditorSaveChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

procedure TTMSFNCChartAxisEditor.SetAppearance;
var
  {$IFDEF VCLLIB}
  LDetails: TThemedElementDetails;
  clr: TTMSFNCGraphicsColor;
  {$ENDIF}
  okfntCol, fntCol, fillCol, primCol: TTMSFNCGraphicsColor;
  SubPanelFillCol, SubPanelStrokecol, MainPanelCol: TTMSFNCGraphicsColor;
begin
  primCol := EDITORPRIMCOLOR;
  fillCol := EDITORAUTOCOLOR;
  fntCol := EDITORAUTOCOLOR;
  okfntCol := EDITOROKFONTCOLOR;
  SubPanelStrokeCol := EDITORAUTOCOLOR;
  SubPanelFillCol := EDITORAUTOCOLOR;
  MainPanelCol := EDITORAUTOCOLOR;
  {$IFDEF VCLLIB}
  if TTMSFNCChartOpen(FChart).VCLStylesEnabled then
  begin
    clr := StyleServices.GetStyleColor(scButtonHot);
    if clr <> clNone then
      primCol := clr;

    LDetails := StyleServices.GetElementDetails(ttbButtonPressed);
    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      okfntCol := clr;

//    LDetails := StyleServices.GetElementDetails(ttbButtonHot);
//    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
//    begin
//      fc := clr;
////      okfntCol := clr;
//    end;

    LDetails := StyleServices.GetElementDetails(ttbButtonNormal);

    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      fillCol := clr;

    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      fntCol := clr;

    LDetails := StyleServices.GetElementDetails(tpPanelBackground);
    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      SubPanelFillCol := clr;
    if StyleServices.GetElementColor(LDetails, ecBorderColor, clr) and (clr <> clNone) then
      SubPanelStrokeCol := clr;

    clr := StyleServices.GetSystemColor(clBtnFace);
    if (clr <> clNone) then
    begin
      MainPanelCol := clr;
    end;
  end;
  FButtonOk.StyleElements := FButtonOk.StyleElements - [seClient];
  FButtonCancel.StyleElements := FButtonCancel.StyleElements - [seClient];

  FXPanel.StyleElements := FXPanel.StyleElements - [seClient];
  FPanel.StyleElements := FPanel.StyleElements - [seClient];
  {$ENDIF}

  SetEditorOKButtonAppearance(FButtonOk,primCol, EDITORBUTTONROUNDING, okfntCol);
  SetEditorCancelButtonAppearance(FButtonCancel, primCol, EDITORBUTTONROUNDING, fntCol, fillCol);

  SetEditorSubPanelAppearance(FXPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorBackPanelAppearance(FPanel, MainPanelCol, MainPanelCol);
end;

procedure TTMSFNCChartAxisEditor.SetAxis(const Value: TTMSFNCChartAxisEditorAxisType);
begin
  if FAxis <> Value then
  begin
    FAxis := Value;
    SetAxisProperties;
  end;
end;

procedure TTMSFNCChartAxisEditor.SetAxisProperties;
begin
  if FAxis = eatXAxis then
  begin
    {$IFDEF FMXLIB}
    FBottomLabel.Text := TranslateTextEx(sTMSFNCChartAxisEditorBottom);
    FTopLabel.Text := TranslateTextEx(sTMSFNCChartAxisEditorTop);
    FSizeLabel.Text := TranslateTextEx(sTMSFNCChartAxisEditorHeight);
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FBottomLabel.Caption := TranslateTextEx(sTMSFNCChartAxisEditorBottom);
    FTopLabel.Caption := TranslateTextEx(sTMSFNCChartAxisEditorTop);
    FSizeLabel.Caption := TranslateTextEx(sTMSFNCChartAxisEditorHeight);
    {$ENDIF}
  end
  else
  begin
    {$IFDEF FMXLIB}
    FBottomLabel.Text := TranslateTextEx(sTMSFNCChartAxisEditorRight);
    FTopLabel.Text := TranslateTextEx(sTMSFNCChartAxisEditorLeft);
    FSizeLabel.Text := TranslateTextEx(sTMSFNCChartAxisEditorWidth);
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FBottomLabel.Caption := TranslateTextEx(sTMSFNCChartAxisEditorRight);
    FTopLabel.Caption := TranslateTextEx(sTMSFNCChartAxisEditorLeft);
    FSizeLabel.Caption := TranslateTextEx(sTMSFNCChartAxisEditorWidth);
    {$ENDIF}
  end;

  ClearEvents;
  Initialize;
end;

procedure TTMSFNCChartAxisEditor.SetChart(const Value: TTMSFNCChart);
begin
  FChart := Value;
end;

{$IFDEF FMXLIB}
{ TTMSFNCChartAppearanceEditorSpinEdit }

constructor TTMSFNCChartAxisEditorSpinEdit.Create(AOwner: TComponent);
begin
  inherited;
  Max := 100000;
  Min := -100000;
end;
{$ENDIF}

{$IFDEF CMNWEBLIB}
constructor TTMSFNCChartAxisEditorComboBox.Create(AOwner: TComponent);
begin
  inherited;
  {$IFDEF VCLLIB}
  {$IF COMPILERVERSION > 34}
  AutoDropDownWidth := True;
  {$IFEND}
  {$ENDIF}
end;

procedure TTMSFNCChartAxisEditor.SetColorComboStyle(AColorcombo: TTMSFNCChartAxisEditorColorCombo);
begin
  {$IFNDEF WEBLIB}
  AColorcombo.Style := [cbStandardColors, cbExtendedColors, cbCustomColor];
  {$ENDIF}
end;
{$ENDIF}

{$IFDEF WEBLIB}

{ TTMSFNCChartAxisEditorForm }

constructor TTMSFNCChartAxisEditorForm.CreateDialogNew(AChartEditor: TTMSFNCChartAxisEditor; ACaption: string);
begin
  FChartEditor := AChartEditor;
  inherited CreateDialogNew(ACaption);
end;

procedure TTMSFNCChartAxisEditorForm.LoadDFMValues;
begin
  inherited LoadDFMValues;
  if Assigned(FChartEditor) then
  begin
    FChartEditor.BuildEditor(Self);
  end;
end;

procedure TTMSFNCChartAxisEditorForm.Loaded;
var
  css: string;
begin
  inherited;

  css := Application.IDECSS;

  if (css <> '') then
  begin
    AddCSS('IDECSS', css);
    ElementClassName := 'IDEBkg';
    CaptionElement['class'] := 'IDECaption IDEFont';
    if Assigned(FChartEditor) then
      FChartEditor.ApplyCSS(css);
  end;
end;
{$ENDIF}

end.
